import { useCallback, useContext } from 'react';
import { FilterProviderContext } from 'components/filter/filters-next/FilterProvider';
import { useFiltersByKey } from 'components/filter/filters-next/useFiltersByKey';
import { FilterGroup } from 'components/filter/types';
import { useFiltersCache } from 'contexts/useFiltersCache';
import { cloneDeep } from 'lodash';

const useUpdateFiltersByResource = () => {
    const { cacheKey } = useContext(FilterProviderContext);
    const { filterGroups } = useFiltersByKey(cacheKey);
    const updateFilter = useFiltersCache(state => state.updateFiltersNextByKey);

    return useCallback(
        (mutableValues: FilterGroup) => {
            const mutableGroups = cloneDeep(filterGroups);
            const foundIndex = mutableGroups.findIndex(f => f.id === mutableValues.id);

            if (foundIndex !== -1) {
                mutableGroups[foundIndex] = mutableValues;
            } else {
                mutableGroups.push(mutableValues);
            }

            updateFilter(cacheKey, mutableGroups);
        },
        [cacheKey, filterGroups, updateFilter],
    );
};

export { useUpdateFiltersByResource };
